export default "__VITE_ASSET__BdaR0MCs__"